// @ts-expect-error
tinymce.PluginManager.add("quizlink", function (editor, url) {
	const openDialog = () => {
		const element = editor.getElement();
		if (!$(element).attr("data-game-id")) {
			alert("No Game id given");
			return;
		}
		$.ajax({
			type: "GET",
			url: `/games/${$(element).attr("data-game-id")}/rtf_infos/load_game_quizzes_for_link_select`,
			dataType: "json",
			success: function (data) {
				const quizzes = [];
				data.forEach((arrayItem) => {
					quizzes.push({ text: arrayItem, value: arrayItem });
				});
				return editor.windowManager.open({
					title: I18n.t("helpers.submit.new", {
						model: `${I18n.t("activerecord.models.quiz", { count: 1 })}-Link`,
					}),
					body: {
						type: "panel",
						items: [
							{
								type: "selectbox",
								items: quizzes,
								name: "quiz_name",
								label: I18n.t("activerecord.models.quiz.one"),
							},
							{
								type: "input",
								name: "btn_text",
								label: "Button text",
							},
						],
					},
					buttons: [
						{
							type: "cancel",
							text: I18n.t("global.actions.close"),
						},
						{
							type: "submit",
							text: I18n.t("global.actions.save"),
							primary: true,
						},
					],
					onSubmit: function (api) {
						const data = api.getData();
						/* Insert content when the window form is submitted */
						editor.insertContent(
							`<p><a href='javascript:;' data-quiz-name='${data.quiz_name}'>${data.btn_text}</a></p>`,
						);
						api.close();
					},
				});
			},
		});
	};
	/* Add a menu item that opens a window */
	editor.ui.registry.addMenuItem("quizlink", {
		text: I18n.t("activerecord.models.quiz", { count: 1 }) + "…",
		icon: "link",
		onAction: openDialog,
	});
});
